/* Keep Swym's guest login actions on the store's configured account page. */
(() => {
  'use strict';

  const script = document.currentScript;
  if (window.location.hash === '#swym-wishlist') {
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(swat => {
      if (typeof swat?.ui?.open === 'function') swat.ui.open();
    });
  }

  const accountPage = script?.dataset.accountPage;
  if (!accountPage) return;

  const destination = new URL(accountPage, window.location.origin);
  if (destination.origin !== window.location.origin) return;

  window.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = event.target instanceof Element ? event.target : null;
    const login = target?.closest('.swym-storefront-layout-share-footer-login-btn');
    if (!login) return;

    // Shopify performs authentication; return to this page with the wishlist open.
    destination.searchParams.set(
      'return_to',
      `${window.location.pathname}${window.location.search}#swym-wishlist`
    );
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination.href);
  }, true);
})();
